'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/phone/Iphone.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var IphoneIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "12",
      height: "13",
      viewBox: "0 0 12 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            opacity: "0.3",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 1.75006C3.65482 1.75006 3.375 2.02988 3.375 2.37506V10.6251C3.375 10.9702 3.65482 11.2501 4 11.2501H8C8.34518 11.2501 8.625 10.9702 8.625 10.6251V2.37506C8.625 2.02988 8.34518 1.75006 8 1.75006H4Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 1.00006H8C8.75939 1.00006 9.375 1.61567 9.375 2.37506V10.6251C9.375 11.3845 8.75939 12.0001 8 12.0001H4C3.24061 12.0001 2.625 11.3845 2.625 10.6251V2.37506C2.625 1.61567 3.24061 1.00006 4 1.00006ZM4 1.75006C3.65482 1.75006 3.375 2.02988 3.375 2.37506V10.6251C3.375 10.9702 3.65482 11.2501 4 11.2501H8C8.34518 11.2501 8.625 10.9702 8.625 10.6251V2.37506C8.625 2.02988 8.34518 1.75006 8 1.75006H7.5V1.62506C7.5 1.48699 7.38807 1.37506 7.25 1.37506H4.75C4.61193 1.37506 4.5 1.48699 4.5 1.62506V1.75006H4ZM4.5 1.75006V2.12506C4.5 2.26313 4.61193 2.37506 4.75 2.37506H7.25C7.38807 2.37506 7.5 2.26313 7.5 2.12506V1.75006H4.5Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/phone/SupportHeadphone.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var SupportHeadphone = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.34711 7.50859C2.403 7.60593 1.66667 8.40378 1.66667 9.37362V12.2903C1.66667 13.3258 2.50614 14.1653 3.54167 14.1653H4.79167C5.13685 14.1653 5.41667 13.8855 5.41667 13.5403V8.12362C5.41667 7.77844 5.13685 7.49862 4.79167 7.49862H4.60207C4.83054 4.9663 7.12198 2.91528 10 2.91528C12.878 2.91528 15.1695 4.9663 15.3979 7.49862H15.2083C14.8632 7.49862 14.5833 7.77844 14.5833 8.12362V13.5403C14.5833 13.8855 14.8632 14.1653 15.2083 14.1653H15.6182C15.511 15.794 14.1559 17.082 12.5 17.082H10.625V16.3677C10.625 16.0225 10.3452 15.7427 10 15.7427C9.65483 15.7427 9.37501 16.0225 9.37501 16.3677V17.707C9.37501 18.0521 9.65483 18.332 10 18.332H12.5C14.8618 18.332 16.7865 16.4604 16.872 14.1195C17.7085 13.9311 18.3333 13.1837 18.3333 12.2903V9.37362C18.3333 8.40378 17.597 7.60593 16.6529 7.50859C16.4287 4.21058 13.4966 1.66528 10 1.66528C6.50337 1.66528 3.5713 4.21058 3.34711 7.50859ZM15.8333 8.74862H16.4583C16.8035 8.74862 17.0833 9.02844 17.0833 9.37362V12.2903C17.0833 12.6355 16.8035 12.9153 16.4583 12.9153H15.8333V8.74862ZM3.54167 8.74862C3.19649 8.74862 2.91667 9.02844 2.91667 9.37362V12.2903C2.91667 12.6355 3.19649 12.9153 3.54167 12.9153H4.16667V8.74862H3.54167Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/phone/Telephone.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var TelephoneIcon = (props) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.00197 3.95768C3.00815 3.54793 3.34208 3.21899 3.75188 3.21899H9C9.33271 3.21899 9.62565 3.43818 9.71952 3.75737L10.9695 8.00737C11.0485 8.27595 10.9714 8.56616 10.7694 8.76003L9.29367 10.1767C10.4035 12.1666 12.0524 13.8155 14.0423 14.9253L15.459 13.4496C15.6528 13.2476 15.943 13.1705 16.2116 13.2495L20.4616 14.4995C20.7808 14.5933 21 14.8863 21 15.219V20.469C21 20.8832 20.6642 21.219 20.25 21.219H20C16.897 21.219 13.9861 20.387 11.4806 18.9333C8.9147 17.4446 6.77436 15.3043 5.28566 12.7384C3.83203 10.2329 3 7.32196 3 4.21899C3 4.13174 3.00066 4.04464 3.00197 3.95768ZM4.50791 4.71899C4.59162 7.36267 5.33684 9.83754 6.58311 11.9856C7.94076 14.3257 9.89333 16.2782 12.2334 17.6359C14.3815 18.8822 16.8563 19.6274 19.5 19.7111V15.7802L16.2255 14.8171L14.7329 16.3719C14.5053 16.6089 14.1501 16.6703 13.8563 16.5233C11.1952 15.1921 9.02685 13.0238 7.69571 10.3627C7.54874 10.0689 7.61008 9.71365 7.84707 9.48614L9.40191 7.9935L8.43882 4.71899H4.50791Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  IphoneIcon,
  SupportHeadphone,
  TelephoneIcon
};
//# sourceMappingURL=chunk-SDMCJ2FK.mjs.map